import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes:{
            light:{
                primary: '#f1f1f1',
                secondary: '#00a56b',
                info: '#f9a825',
                error: '#B00020',
                tertiary: '#c6c6c6'
                
            },
            dark:{
                primary:'#646464',
                secondary:'#00a56b',
                info:'#f9a825',
                error: '#B00020',
                tertiary: '#c6c6c6',
            }

        },
            
    },
});
